import Shoes from '@/assets/icons/categories/boot-heeled.svg'
import Electronics from '@/assets/icons/categories/computer-speaker.svg'
import Vitamins from '@/assets/icons/categories/head-side-brain.svg'
import Cosmetics from '@/assets/icons/categories/lipstick.svg'
import Outdoors from '@/assets/icons/categories/table-picnic.svg'
import Food from '@/assets/icons/categories/pizza-slice.svg'
import Accessories from '@/assets/icons/categories/sunglasses-alt.svg'
import Toys from '@/assets/icons/categories/teddy-bear.svg'
import Clothes from '@/assets/icons/categories/tshirt.svg'
import HomeElectronics from '@/assets/icons/categories/lamp.svg'
import Placeholder from '@/assets/icons/categories/category.svg'

const CategoryIdToIcon = {
  0: Placeholder,
  2: Electronics,
  2511: Clothes,
  1932: Shoes,
  1941: Accessories,
  1984: Cosmetics,
  2098: Vitamins,
  2037: Outdoors,
  588: Toys,
  1906: Food,
  446: HomeElectronics,
}
export default (id: number) => {
  const icon = CategoryIdToIcon[id]

  return icon ?? Placeholder
}
